import KaMenu from './KaMenu.vue';
import KaMenuGroup from './KaMenuGroup.vue';
import KaMenuItem from './KaMenuItem.vue';
import KaMenuPortal from './KaMenuPortal.vue';

export type { KaMenuGroupProps, KaMenuItemProps, KaMenuProps } from './types';

KaMenu.Group = KaMenuGroup;
KaMenu.Item = KaMenuItem;
KaMenu.Portal = KaMenuPortal;

const newKaMenu = KaMenu as typeof KaMenu & {
  readonly Group: typeof KaMenuGroup;
  readonly Item: typeof KaMenuItem;
  readonly Portal: typeof KaMenuPortal;
};

export { KaMenuGroup };
export { newKaMenu as KaMenu };
